export default __webpack_public_path__ + "static/locate_black-1f7976cb1fa4c41868d1897c349a5b11.png";